import { Box, Pagination } from "@mui/material";
import StrategyCard from "./StrategyCard";
import StrategyCardSkeleton from "./StrategyCardSkeleton";
import EmptyState from "./EmptyState";

const SKELETON_COUNT = 12;

const StrategyGrid = ({
  strategies,
  loading,
  onAddToCart,
  searchTerm,
  pagination,
  currentPage,
  onPageChange,
}) => {
  
  if (loading && strategies.length === 0) {
    return (
    <Box
      sx={{
        p: 0,
        gap: 2,
        display: "grid",
        gridTemplateColumns: {
          xs: "1fr",
          sm: "repeat(2, 1fr)",
          md: "repeat(3, 1fr)",
          lg: "repeat(4, 1fr)"
        }
    }}>

          {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
            
            <StrategyCardSkeleton key={index} />
          ))}
        </Box>
    );
  }

  if (strategies.length === 0) {
    return <EmptyState searchTerm={searchTerm} />;
  }

  return (
    <>
      <Box
        sx={{
          p: 0,
          gap: 2,
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "repeat(2, 1fr)",
            md: "repeat(3, 1fr)",
            lg: "repeat(4, 1fr)"
          }
      }}>
        {strategies.map((strategy) => (
            <StrategyCard
              key={strategy.idStrategy}
              strategyID={strategy.idStrategy}
              title={strategy.title}
              description={strategy.description}
              onAddToCart={onAddToCart}
              chartData={strategy.chartData || []}
              loading={loading}
              sharpeRatio={strategy.sharpeRatio}
            />
        ))}
      </Box>

      {pagination?.totalPages > 1 && (
        <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
          <Pagination
            count={pagination.totalPages}
            page={currentPage}
            onChange={(_, page) => onPageChange(page)}
            color="primary"
            shape="rounded"
            showFirstButton
            showLastButton
            disabled={loading}
          />
        </Box>
      )}
    </>
  );
};

export default StrategyGrid;
